export default "__VITE_ASSET__cf477167__"